export default {
  computed: {
    currentStandId () {
      return this.$store.state.currentStand
    },
    activeStand () {
      let stands = this.$store.state.stands
      if (stands.length === 0) return null
      return stands.find(stand => stand.isActive === true)
    }
  },
  methods: {
    standIscompleted (curentJobId, standId) {
      let stands = this.$store.state.stands

      if (stands.length === 0) return null
      return stands.find(stand => stand.isCompleted === true && stand.jobId === curentJobId && stand.standId === standId)
    },
    createStand (standId, standClass, jobId, deliveryId, product, quantity) {
      let stand = {
        jobId: jobId,
        standId: standId || null,
        deliveryId: deliveryId || null,
        product: product || null,
        quantity: quantity || null,
        class: standClass,
        isActive: false,
        isCompleted: false,
        isSkipped: false
      }
      this.$store.commit('createStands', stand)
    },
    getCompletedStands () {
      let stands = this.$store.state.stands
      return stands.filter(stand => stand.isCompleted)
    },
    getSkippedStands () {
      let stands = this.$store.state.stands
      return stands.filter(stand => stand.isSkipped)
    }
  }
}
